import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CopyOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CopyOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M19.5 6.5h-2v-2c0-2.21-1.79-4-4-4h-9c-2.21 0-4 1.79-4 4v9c0 2.21 1.79 4 4 4h2v2c0 2.21 1.79 4 4 4h9c2.21 0 4-1.79 4-4v-9c0-2.21-1.79-4-4-4Zm-15 9c-1.1 0-2-.9-2-2v-9c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2h-9Zm17 4c0 1.1-.9 2-2 2h-9c-1.1 0-2-.9-2-2v-2h5c2.21 0 4-1.79 4-4v-5h2c1.1 0 2 .9 2 2v9Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default CopyOutlined;